import { createField } from '@cks-internal/react-base';
import { SelectOption } from '@cks-internal/react-base/dist/Forms/BaseInputs/Inputs/selects/types';
import { ApiEndpoints } from '../../../constants/endpoints/apiEndpoints.ts';
import { NewTravellerInputAddon } from '../../../features/activities/travellers/newTravellerInputAddon';
import { SelectedTravellerPill } from '../../../features/activities/travellers/selectedTravellerPill';
import { SimpleTravellerPill } from '../../../features/activities/travellers/simpleTravellerPill';
import { HotelBookingType } from '../../../globalModels/common/hotelBookingType';
import { CompanyContactType } from '../../../enums/crm/CompanyContactType';

export const CompanyContactsSearchField = createField(
  'multiSelectQuerySearchItems',
  (props: {
    companyId: number | undefined | null;
    approvedBookerOnly: boolean;
    hotelBookingType: HotelBookingType | undefined;
    allowSelectingDisabled?: boolean;
    initialTravelers?: SelectOption[];
    companyContactTypes?: CompanyContactType[];
  }) => ({
    searchUrl: `${ApiEndpoints.selectOptions.companies.companyContactsSearch(props.companyId, props.approvedBookerOnly, props.hotelBookingType, props.allowSelectingDisabled, true, props.companyContactTypes ?? [CompanyContactType.StandardTraveller])}`,
    enabled: props.companyId != undefined,
    minSearchChars: 1,
    initialOptions: props.initialTravelers
  }),
  /**
   * Enhanced company contacts search field with traveler pill customization.
   * Supports both full-featured traveler pills (with stars) and simple pills (avatar + name only).
   *
   * @param input - Base field input configuration
   * @param config - Configuration object with pill display options
   * @param config.useSimplePill - When true, uses SimpleTravellerPill instead of SelectedTravellerPill
   */
  (
    input,
    config?: {
      companyId: number | undefined;
      onCreated: (newTraveller: SelectOption[]) => void;
      activityId: number | undefined;
      noDrag?: boolean;
      disableClick?: boolean;
      useSimplePill?: boolean;
    }
  ) =>
    input
      .withInputProps({
        disableSort: true,
        components: {
          MultiValueLabel: (props) => {
            if (config?.useSimplePill) {
              return <SimpleTravellerPill key={`simple-${props.data.Value}`} selectOption={props.data} />;
            }

            const isPrimary =
              props.data.Metadata?.find((x: { Key: string; Value: any }) => x.Key === 'isPrimary')?.Value === true;
            return (
              <SelectedTravellerPill
                key={`${props.data.Value}-${isPrimary ? 'primary' : 'not-primary'}`}
                selectOption={props.data}
                activityId={config?.activityId}
                disableClick={config?.disableClick}
              />
            );
          }
        }
      })
      .withInputAddons(
        config != undefined
          ? {
              inputRightAddon: (
                <NewTravellerInputAddon
                  activityId={config.activityId}
                  noDrag={config.noDrag}
                  companyId={config.companyId}
                  onCreated={config.onCreated}
                  disabledMessages={undefined}
                />
              )
            }
          : {}
      )
      .isNumeric()
);
